import React, { useEffect, useRef, useState, useCallback } from 'react'
import './ImageGalleryPopup.css'
import axios from 'axios';
import crossButton from '../../../../Assets/Images/cross-button-32-X-32.png'
import arrowDown from '../../../../Assets/Images/dropdown 20 x 20.png'
import uploadImageIcon from '../../../../Assets/Images/uploadImg 48 x 48.png'
import InputField from '../../InputField/InputField';
import { Url, DYRUrl, security_key } from '../../../../Services/Api'

const ImageGalleryPopup = ({
    showImageGalleryPopUp,
    handleModalView,
    onImageSelect,
    setImageSendPayload,
    imageSendPayload,
    data,
    handleFileChange,
    editGalleryImageApi,
    getData,
    allowMultiple = false,
    page,
    setPage,
    hasMore,
    searchValue,
    onSearchChange,
    isSearchLoading,
    forDYR,
}) => {

    const [activeTab, setActiveTab] = useState('gallery');
    const fileInputRef = useRef(null)
    const [selectedImage, setSelectedImage] = useState(null)
    const [selectedImages, setSelectedImages] = useState([])
    const [selectedImageId, setSelectedImageId] = useState(null)
    const [isEditAble, setIsEditAble] = useState(false);
    const [filterOpenIndex, setFilterOpenIndex] = useState(null);
    const [selectedImageIndex, setSelectedImageINdex] = useState(null)
    const [originalValues, setOriginalValues] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [sortedImages, setSortedImages] = useState();

    useEffect(() => {
        const sortImage = [...data]?.sort((a, b) => {
            return new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime();
        });
        setSortedImages(sortImage)
    }, [showImageGalleryPopUp, data])

    const handleSelectImageId = (index) => {
        setSelectedImageINdex(index);
    }

    const onUpload = (e) => {
        handleFileChange(e)
        setActiveTab('gallery')
        setIsLoading(true)
        setTimeout(() => {
            setIsLoading(false)
        }, 1500)
    }

    const handleImageUploadChange = (event) => {
        const { name, value } = event.target;
        setImageSendPayload((prevData) => ({
            ...prevData,
            [name]: value,
        }))
        setSelectedImage((prev) => ({ ...prev, [name]: value }));
    }

    const hansChange = () => {
        return Object.keys(originalValues).some((key) => originalValues[key] !== selectedImage[key]);
    };

    const handleUpdate = async (e) => {
        e.stopPropagation()

        const payload = {
            alt_text: selectedImage.alt_text,
            title: selectedImage.title,
            description: selectedImage.description,
            link_url: selectedImage.link_url,
        };

        if (imageSendPayload.file) {
            payload.file = imageSendPayload.file;
        }

        const formData = new FormData();
        formData.append('alt_text', payload.alt_text);
        formData.append('title', payload.title)
        formData.append('description', payload.description);
        formData.append('link_url', payload.link_url);

        try {
            const token = sessionStorage.getItem('authToken');
            const headers = {
                Authorization: `Bearer ${token}`,
                'x-api-key': security_key
            };
            const response = await axios.put(`${Url + editGalleryImageApi + selectedImage._id}`, formData, { headers: headers });
            if (response.status === 200) {
                getData()
                console.log("working,for reload")
            }
            setOriginalValues(({ ...selectedImage }));
            setIsEditAble(false);
        } catch (error) {
            console.error('updating failed', error);
        }
    }

    const handleSelectedImage = (item) => {
        setSelectedImage(item);
        setSelectedImageId(item._id);
        setOriginalValues({ ...item });

        if (allowMultiple) {
            setSelectedImages((prev) => {
                const isAlreadySelected = prev.some((img) => img._id === item._id);
                if (isAlreadySelected) {
                    return prev.filter((img) => img._id !== item._id); // Deselect if already selected
                }
                return [...prev, item]; // Select
            });
        } else {
            setSelectedImages([item]); // Only one image at a time
        }

        console.log("Here is selection:", allowMultiple ? selectedImages : item);
    };



    const setImageToCMS = (e) => {
        allowMultiple ? onImageSelect(selectedImages) : onImageSelect(selectedImage)
    }

    const imageGalleryFilterData = [
        { name: 'All media items', items: ['item one', 'item two', 'item three'] },
        // { name: 'All media items', items: ['item one', 'item two', 'item three'] },
    ]

    const tabs = [
        { id: 'upload', label: 'Upload Image' },
        { id: 'gallery', label: 'Media Gallery' },
    ];

    const imageEditInputData = [
        { label: 'Alternate Text', placeholder: 'Text', val: 'alt_text', name: 'alt_text' },
        { label: 'Title', placeholder: 'Title', val: 'title', name: 'title' },
        { label: 'Description', placeholder: 'Description', val: 'description', name: 'description' },
        { label: 'Url', placeholder: 'url', val: 'link_url', name: 'link_url' }
    ]

    const handleTabActive = (id) => {
        setActiveTab(id);
    }

    const handleFilterOpen = (index) => {
        setFilterOpenIndex((prevIndex) => (prevIndex === index ? null : index));
    }

    const handleEditInput = () => {
        setIsEditAble(!isEditAble)
    }

    const handleImageClick = () => {
        fileInputRef.current.click();
    }

    const changeDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString(undefined, options);
    };


    const observer = useRef();

    const lastImageRef = useCallback(
        (node) => {
            if (!hasMore) return;
            if (observer.current) observer.current.disconnect();

            observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    setPage((prev) => {
                        const nextPage = prev + 1;
                        getData(nextPage); // Load more data
                        return nextPage;
                    });
                }
            });

            if (node) observer.current.observe(node);
        },
        [hasMore, getData, setPage]
    );


    return (
        <div
            className={`image-gallery-pop-up-main-container 
            ${showImageGalleryPopUp ? 'show-image-gallery-pop-up' : ''}`
            }
        >
            <div className='image-gallery-inner-container'>
                {isLoading && <div className='image-gallery-popup-loader'></div>}

                <button type='button' onClick={handleModalView} className='image-gallery-close-modal' >
                    <img src={crossButton} alt='close-modal-button' />
                </button>

                <div className='image-gallery-header-section'>
                    <p onClick={handleModalView} className='image-gallery-heading'>Add image to product gallery</p>
                    <div className='image-gallery-tabs-select'>
                        {tabs.map(tab => (
                            <div
                                key={tab.id}
                                className={`image-gallery-tab ${activeTab === tab.id ? 'active' : ''}`}
                                onClick={() => handleTabActive(tab.id)}
                            >
                                <p>{tab.label}</p>
                            </div>
                        ))}
                    </div>
                </div>

                <div className='image-gallery-main-containt-section'>
                    <div className="content">
                        <div className={`content-item ${activeTab === 'upload' ? 'active' : ''}`}>
                            <div className='upload-images-main-container'>
                                <p>Click or Drag to Upload</p>
                                <div className='upload-image-icon-div' onClick={handleImageClick}>
                                    <img src={uploadImageIcon} alt='upload-image' />
                                    <input
                                        type='file'
                                        accept='image/*'
                                        ref={fileInputRef}
                                        style={{ display: 'none' }}
                                        onChange={onUpload}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className={`content-item ${activeTab === 'gallery' ? 'active' : ''}`}>
                            <div className='image-gallery'>
                                <div className='image-gallery-select-images-section'>

                                    <h3>Filter Media</h3>
                                    <div className='image-gallery-filter-dropdown-section'>
                                        {imageGalleryFilterData.map((items, index) => (
                                            <div className={`image-gallery-filter`} onClick={() => handleFilterOpen(index)}>
                                                <div className='image-gallery-filter-name'>
                                                    <p>{items.name}</p>
                                                    <img src={arrowDown} alt='arrow-down' className={`filter-arrow-down ${filterOpenIndex === index ? 'rotate-filter-icon' : ''}`} />
                                                </div>
                                                <div
                                                    className={`image-gallery-dropdown 
                                                        ${filterOpenIndex === index ? 'show-filters' : ''}`}
                                                >
                                                    {items.items.map((item, index) => (
                                                        <p>{item}</p>
                                                    ))}
                                                </div>

                                            </div>
                                        ))}
                                        <div className='image-gallery-popup-search-cont' style={{ position: "relative" }}>
                                            <p>Search Media</p>
                                            <input onChange={onSearchChange} value={searchValue} type='text' placeholder='File Name' />
                                            {isSearchLoading && <div style={{ borderTop: "4px solid var(--Dark-Blue)", position: "absolute", right: "0px" }} className="btn-loader-Publish"></div>}
                                        </div>
                                    </div>

                                    <div className='images-gallery-and-detail-section'>
                                        {sortedImages && sortedImages.length > 0 ? (
                                            sortedImages.map((item, index) => {
                                                const isLastImage = index === sortedImages.length - 1;
                                                return (
                                                    <div
                                                        key={item._id}
                                                        ref={isLastImage ? lastImageRef : null}
                                                        className={`image-gallery-section ${allowMultiple
                                                            ? selectedImages.some((img) => img._id === item._id)
                                                                ? 'select-image'
                                                                : ''
                                                            : selectedImageIndex === index
                                                                ? 'select-image'
                                                                : ''
                                                            }`}
                                                    >
                                                        <div className="checkbox-design"></div>
                                                        <img
                                                            src={`${(forDYR ? DYRUrl : Url) + item.image_url}`}
                                                            alt={item.alt_text || 'Image'}
                                                            onClick={() => {
                                                                handleSelectedImage(item);
                                                                handleSelectImageId(index);
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            Array.from({ length: 10 }).map((_, index) => (
                                                <div key={index} className="image-gallery-images-shimmer"></div>
                                            ))
                                        )}
                                    </div>

                                </div>

                                <div className='images-containt-section'>
                                    {selectedImage && Object.keys(selectedImage).length > 0 ? (
                                        <div className='selected-image-full-details'>

                                            <div className='edit-image-container'>
                                                {selectedImage && <img src={selectedImage && `${(forDYR ? DYRUrl : Url) + selectedImage.image_url}`} alt='check' />}
                                            </div>


                                            <div className='image-details-section'>
                                                <h3>{selectedImage && selectedImage.title}</h3>
                                                <p>{selectedImage && changeDate(selectedImage.updatedAt)}</p>
                                                <p>132 kb</p>
                                                <p>1400 x 906</p>
                                            </div>

                                            <div className='edit-and-delete-image-section'>
                                                <button className='edit-image-button' onClick={handleEditInput}>
                                                    Edit image
                                                </button>
                                                <button className='delete-image-button'>
                                                    Delete Image Permanently
                                                </button>
                                            </div>

                                            <div className='image-gallery-inputs'>
                                                {imageEditInputData.map((items, index) => (
                                                    <InputField
                                                        key={index}
                                                        labelText={items.label}
                                                        color={'#595959'}
                                                        fontSize={'15px'}
                                                        fontWeight={'600'}
                                                        lineHeight={'18px'}
                                                        type={'text'}
                                                        placeholder={items.placeholder}
                                                        value={selectedImage ? selectedImage[items.name] : ''}
                                                        name={items.name}
                                                        onChange={handleImageUploadChange}
                                                        readOnly={!isEditAble}
                                                    />
                                                ))}
                                            </div>
                                            {isEditAble && (
                                                <button className='update-image-button' onClick={handleUpdate}>
                                                    Update
                                                </button>
                                            )}
                                        </div>
                                    ) : null}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className={`image-gallery-modal-footer ${activeTab === 'upload' ? 'image-gallery-footer-hide' : ''}`}>
                    {selectedImage && (
                        <button className={`add-to-gallery-btn`} type='button' onClick={setImageToCMS}>
                            Add to gallery
                        </button>
                    )}
                </div>

            </div>
        </div>
    )
}

export default ImageGalleryPopup























































// import React, { useEffect, useRef, useState } from 'react'
// import './ImageGalleryPopup.css'
// import axios from 'axios';
// import crossButton from '../../../../Assets/Images/cross-button-32-X-32.png'
// import arrowDown from '../../../../Assets/Images/dropdown 20 x 20.png'
// import uploadImageIcon from '../../../../Assets/Images/uploadImg 48 x 48.png'
// import InputField from '../../InputField/InputField';
// import { Url } from '../../../../Services/Api'

// const ImageGalleryPopup = ({
//     showImageGalleryPopUp,
//     handleModalView,
//     onImageSelect,
//     setImageSendPayload,
//     imageSendPayload,
//     data,
//     handleFileChange,
//     editGalleryImageApi,
//     getData,
//     allowMultiple = true,
// }) => {

//     const [activeTab, setActiveTab] = useState('gallery');
//     const fileInputRef = useRef(null)
//     const [selectedImage, setSelectedImage] = useState(null)
//     const [selectedImages, setSelectedImages] = useState([])
//     const [selectedImageId, setSelectedImageId] = useState(null)
//     const [isEditAble, setIsEditAble] = useState(false);
//     const [filterOpenIndex, setFilterOpenIndex] = useState(null);
//     const [selectedImageIndex, setSelectedImageINdex] = useState(null)
//     const [originalValues, setOriginalValues] = useState({});
//     const [isLoading, setIsLoading] = useState(false);
//     const [sortedImages, setSortedImages] = useState();

//     useEffect(() => {
//         const sortImage = [...data]?.sort((a, b) => {
//             return new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime();
//         });
//         setSortedImages(sortImage)
//     }, [showImageGalleryPopUp, data])

//     const handleSelectImageId = (index) => {
//         setSelectedImageINdex(index);
//     }

//     const onUpload = (e) => {
//         handleFileChange(e)
//         setActiveTab('gallery')
//         setIsLoading(true)
//         setTimeout(() => {
//             setIsLoading(false)
//         }, 1500)
//     }

//     const handleImageUploadChange = (event) => {
//         const { name, value } = event.target;
//         setImageSendPayload((prevData) => ({
//             ...prevData,
//             [name]: value,
//         }))
//         setSelectedImage((prev) => ({ ...prev, [name]: value }));
//     }

//     const hansChange = () => {
//         return Object.keys(originalValues).some((key) => originalValues[key] !== selectedImage[key]);
//     };

//     const handleUpdate = async (e) => {
//         e.stopPropagation()

//         const payload = {
//             alt_text: selectedImage.alt_text,
//             title: selectedImage.title,
//             description: selectedImage.description,
//             link_url: selectedImage.link_url,
//         };

//         if (imageSendPayload.file) {
//             payload.file = imageSendPayload.file;
//         }

//         const formData = new FormData();
//         formData.append('alt_text', payload.alt_text);
//         formData.append('title', payload.title)
//         formData.append('description', payload.description);
//         formData.append('link_url', payload.link_url);

//         try {
//             const response = await axios.put(`${Url + editGalleryImageApi + selectedImage._id}`, formData);
//             if (response.status === 200) {
//                 getData()
//             }
//             setOriginalValues(({ ...selectedImage }));
//             setIsEditAble(false);
//         } catch (error) {
//             console.error('updating failed', error);
//         }
//     }

//     const handleSelectedImage = (item) => {
//         setSelectedImage(item);
//         setSelectedImageId(item._id);
//         setOriginalValues({ ...item });

//         if (allowMultiple) {
//             setSelectedImages((prev) => {
//                 const isAlreadySelected = prev.some((img) => img._id === item._id);
//                 if (isAlreadySelected) {
//                     return prev.filter((img) => img._id !== item._id); // Deselect if already selected
//                 }
//                 return [...prev, item]; // Select
//             });
//         } else {
//             setSelectedImages([item]); // Only one image at a time
//         }

//         console.log("Here is selection:", allowMultiple ? selectedImages : item);
//     };



//     const setImageToCMS = (e) => {
//        allowMultiple ? onImageSelect(selectedImages) :  onImageSelect(selectedImage)
//     }

//     const imageGalleryFilterData = [
//         { name: 'All media items', items: ['item one', 'item two', 'item three'] },
//         { name: 'All media items', items: ['item one', 'item two', 'item three'] },
//     ]

//     const tabs = [
//         { id: 'upload', label: 'Upload Image' },
//         { id: 'gallery', label: 'Media Gallery' },
//     ];

//     const imageEditInputData = [
//         { label: 'Alternate Text', placeholder: 'Text', val: 'alt_text', name: 'alt_text' },
//         { label: 'Title', placeholder: 'Title', val: 'title', name: 'title' },
//         { label: 'Description', placeholder: 'Description', val: 'description', name: 'description' },
//         { label: 'Url', placeholder: 'url', val: 'link_url', name: 'link_url' }
//     ]

//     const handleTabActive = (id) => {
//         setActiveTab(id);
//     }

//     const handleFilterOpen = (index) => {
//         setFilterOpenIndex((prevIndex) => (prevIndex === index ? null : index));
//     }

//     const handleEditInput = () => {
//         setIsEditAble(!isEditAble)
//     }

//     const handleImageClick = () => {
//         fileInputRef.current.click();
//     }

//     const changeDate = (dateString) => {
//         const options = { year: 'numeric', month: 'long', day: 'numeric' };
//         const date = new Date(dateString);
//         return date.toLocaleDateString(undefined, options);
//     };

//     return (
//         <div
//             className={`image-gallery-pop-up-main-container
//             ${showImageGalleryPopUp ? 'show-image-gallery-pop-up' : ''}`
//             }
//         >
//             <div className='image-gallery-inner-container'>
//                 {isLoading && <div className='image-gallery-popup-loader'></div>}

//                 <button type='button' onClick={handleModalView} className='image-gallery-close-modal' >
//                     <img src={crossButton} alt='close-modal-button' />
//                 </button>

//                 <div className='image-gallery-header-section'>
//                     <p onClick={handleModalView} className='image-gallery-heading'>Add image to product gallery</p>
//                     <div className='image-gallery-tabs-select'>
//                         {tabs.map(tab => (
//                             <div
//                                 key={tab.id}
//                                 className={`image-gallery-tab ${activeTab === tab.id ? 'active' : ''}`}
//                                 onClick={() => handleTabActive(tab.id)}
//                             >
//                                 <p>{tab.label}</p>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 <div className='image-gallery-main-containt-section'>
//                     <div className="content">
//                         <div className={`content-item ${activeTab === 'upload' ? 'active' : ''}`}>
//                             <div className='upload-images-main-container'>
//                                 <p>Click or Drag to Upload</p>
//                                 <div className='upload-image-icon-div' onClick={handleImageClick}>
//                                     <img src={uploadImageIcon} alt='upload-image' />
//                                     <input
//                                         type='file'
//                                         accept='image/*'
//                                         ref={fileInputRef}
//                                         style={{ display: 'none' }}
//                                         onChange={onUpload}
//                                     />
//                                 </div>
//                             </div>
//                         </div>

//                         <div className={`content-item ${activeTab === 'gallery' ? 'active' : ''}`}>
//                             <div className='image-gallery'>
//                                 <div className='image-gallery-select-images-section'>

//                                     <h3>Filter Media</h3>
//                                     <div className='image-gallery-filter-dropdown-section'>
//                                         {imageGalleryFilterData.map((items, index) => (
//                                             <div className={`image-gallery-filter`} onClick={() => handleFilterOpen(index)}>
//                                                 <div className='image-gallery-filter-name'>
//                                                     <p>{items.name}</p>
//                                                     <img src={arrowDown} alt='arrow-down' className={`filter-arrow-down ${filterOpenIndex === index ? 'rotate-filter-icon' : ''}`} />
//                                                 </div>
//                                                 <div
//                                                     className={`image-gallery-dropdown
//                                                         ${filterOpenIndex === index ? 'show-filters' : ''}`}
//                                                 >
//                                                     {items.items.map((item, index) => (
//                                                         <p>{item}</p>
//                                                     ))}
//                                                 </div>

//                                             </div>
//                                         ))}
//                                     </div>

//                                     <div className='images-gallery-and-detail-section'>

//                                         {sortedImages && sortedImages.length > 0 ? (
//                                             sortedImages.map((item, index) => (
//                                                 <div
//                                                     key={item._id}
//                                                     className={`image-gallery-section ${allowMultiple
//                                                             ? selectedImages.some((img) => img._id === item._id)
//                                                                 ? 'select-image'
//                                                                 : ''
//                                                             : selectedImageIndex === index
//                                                                 ? 'select-image'
//                                                                 : ''
//                                                         }`}
//                                                 >
//                                                     <div className="checkbox-design"></div>
//                                                     <img
//                                                         src={`${Url + item.image_url}`}
//                                                         alt={item.alt_text || 'Image'}
//                                                         onClick={() => {
//                                                             handleSelectedImage(item);
//                                                             handleSelectImageId(index);
//                                                         }}
//                                                     />
//                                                 </div>
//                                             ))
//                                         ) : (
//                                             Array.from({ length: 10 }).map((_, index) => (
//                                                 <div key={index} className="image-gallery-images-shimmer"></div>
//                                             ))
//                                         )}


//                                     </div>
//                                 </div>

//                                 <div className='images-containt-section'>
//                                     {selectedImage && Object.keys(selectedImage).length > 0 ? (
//                                         <div className='selected-image-full-details'>

//                                             <div className='edit-image-container'>
//                                                 {selectedImage && <img src={selectedImage && `${Url + selectedImage.image_url}`} alt='check' />}
//                                             </div>


//                                             <div className='image-details-section'>
//                                                 <h3>{selectedImage && selectedImage.title}</h3>
//                                                 <p>{selectedImage && changeDate(selectedImage.updatedAt)}</p>
//                                                 <p>132 kb</p>
//                                                 <p>1400 x 906</p>
//                                             </div>

//                                             <div className='edit-and-delete-image-section'>
//                                                 <button className='edit-image-button' onClick={handleEditInput}>
//                                                     Edit image
//                                                 </button>
//                                                 <button className='delete-image-button'>
//                                                     Delete Image Permanently
//                                                 </button>
//                                             </div>

//                                             <div className='image-gallery-inputs'>
//                                                 {imageEditInputData.map((items, index) => (
//                                                     <InputField
//                                                         key={index}
//                                                         labelText={items.label}
//                                                         color={'#595959'}
//                                                         fontSize={'15px'}
//                                                         fontWeight={'600'}
//                                                         lineHeight={'18px'}
//                                                         type={'text'}
//                                                         placeholder={items.placeholder}
//                                                         value={selectedImage ? selectedImage[items.name] : ''}
//                                                         name={items.name}
//                                                         onChange={handleImageUploadChange}
//                                                         readOnly={!isEditAble}
//                                                     />
//                                                 ))}
//                                             </div>
//                                             {isEditAble && (
//                                                 <button className='update-image-button' onClick={handleUpdate}>
//                                                     Update
//                                                 </button>
//                                             )}
//                                         </div>
//                                     ) : null}
//                                 </div>

//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className={`image-gallery-modal-footer ${activeTab === 'upload' ? 'image-gallery-footer-hide' : ''}`}>
//                     {selectedImage && (
//                         <button className={`add-to-gallery-btn`} type='button' onClick={setImageToCMS}>
//                             Add to gallery
//                         </button>
//                     )}
//                 </div>

//             </div>
//         </div>
//     )
// }

// export default ImageGalleryPopup













